module.exports = __webpack_public_path__ + "media/images/pic/certificates/about-us/big/brc-global-pl-0e8b903f84d66d805bfcad65291bf314.jpg";